import { DefaultResponse } from "../../types/default-response.dto";
import { createAuthClient } from "../auth/auth.client";
import {
  FETCH_ALL_CURRENCIES,
  FETCH_ALL_FIAT_CURRENCIES,
  FETCH_DISTRIBUTOR_DEPOSIT_CURRENCIES,
  UPDATE_ACCOUNT_CURRENCY,
} from "./currencies.queries";

export const getAllFiatCurrencies = async (): Promise<DefaultResponse> => {
  const authClient = createAuthClient();
  return authClient.request(FETCH_ALL_FIAT_CURRENCIES, {});
};

export const getAllCurrencies = async (): Promise<DefaultResponse> => {
  const authClient = createAuthClient();
  return authClient.request(FETCH_ALL_CURRENCIES, {});
};

export const setAccountCurrency = async (
  currencyId: string,
): Promise<DefaultResponse> => {
  const authClient = createAuthClient();
  return authClient.request(UPDATE_ACCOUNT_CURRENCY, { currencyId });
};

export const getDistributorDepositCurrencies =
  async (): Promise<DefaultResponse> => {
    const authClient = createAuthClient();
    return authClient.request(FETCH_DISTRIBUTOR_DEPOSIT_CURRENCIES);
  };
